import React from 'react';

// Using the Simble white.png or similar transparent white logo over the gradient background
// For optimal performance, we use CSS for the main splash logo but provide this component for headers/auth
export const Logo: React.FC<{ 
  className?: string; 
  size?: 'sm' | 'md' | 'lg' | 'xl';
  forceDark?: boolean;
}> = ({ 
  className = '', 
  size = 'md',
  forceDark = true
}) => {
  const heights = {
    sm: 'h-8',
    md: 'h-12',
    lg: 'h-20',
    xl: 'h-28'
  };

  return (
    <div className={`flex items-center justify-center ${className}`}>
      {forceDark ? (
        <img 
          src="/assets/logo/logo-dark.png" 
          alt="Turnifly" 
          className={`${heights[size]} w-auto object-contain block`} 
        />
      ) : (
        <>
          <img 
            src="/assets/logo/logo-light.png" 
            alt="Turnifly" 
            className={`${heights[size]} w-auto object-contain dark:hidden`} 
          />
          <img 
            src="/assets/logo/logo-dark.png" 
            alt="Turnifly" 
            className={`${heights[size]} w-auto object-contain hidden dark:block`} 
          />
        </>
      )}
    </div>
  );
};
